import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import {
  CompanyType,
  SwitchCompanyDropdown,
} from "./Components/companyDropdown";
import { SwitchProduct } from "./Components/SwitchPlatform";
import { logoDarkImage } from "./Components/images";
import { FlyoutProfile } from "./Components/FlyoutProfile";
import FlyoutSettings from "../../modals/FlyoutSetting";
import { useGetPlatformInfo } from "../../queries/auth";
import { getAuthStore, useAuthStore } from "../../store";
import FlyoutNotification from "../../modals/FlyoutNotification";

export function TopBarComponent(props: any) {
  const navigate = useNavigate();
  const { accessToken } = useAuthStore();

  const { data: userPlatformData } = useGetPlatformInfo(
    accessToken || "",
    accessToken !== undefined && accessToken !== ""
  );

  const [platformData, setPlatformData] = useState<any>(null);

  useEffect(() => {
    if (userPlatformData) {
      setPlatformData(userPlatformData);
    }
  }, [userPlatformData]);

  const accessiblePlatforms = Array.from(
    new Set(
      platformData
        ?.filter(
          (platform: any) =>
            platform.data.access && platform.platform !== "captable"
        )
        .map((platform: any) => platform.platform)
    )
  );

  return (
    <div className="sticky top-0 right-0 left-0 z-40 bg-white shadow-box">
      <div
        className={`flex h-14 shrink-0 items-center md:gap-x-4 px-4 sm:gap-x-6 sm:px-6 lg:px-6 ${props.className}`}
      >
        <div
          onClick={() => {
            sessionStorage.clear();
            getAuthStore().clear();
            window.location.href =
              process.env.REACT_APP_ID_SERVER_CLIENT_URL || "";
          }}
        >
          {logoDarkImage ? (
            <img
              className="h-9 mx-auto w-auto cursor-pointer"
              src={logoDarkImage}
              alt="hissa_logo"
            />
          ) : (
            <h2 className="text-4xl font-semibold text-secondary">{"hissa"}</h2>
          )}
        </div>
        <form className="relative flex flex-1" action="#" method="GET"></form>

        <SwitchCompanyDropdown />
        <div className="flex items-center gap-3 md:gap-4">
          <FlyoutNotification />
          <FlyoutSettings />
        </div>
        <div
          className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
          aria-hidden="true"
        />
        <div className="md:block">
          {accessiblePlatforms.length > 0 ? (
            <SwitchProduct data={platformData} />
          ) : (
            <Icon
              icon="icon-park-outline:application-menu"
              className={`text-gray-200 m-2 cursor-not-allowed animate-pulse`}
              height={20}
            />
          )}
        </div>
        <div className="md:block">
          <FlyoutProfile
            profileImage={
              (platformData && platformData[0]?.profilePicUrl) || ""
            }
          />
        </div>
      </div>
    </div>
  );
}
